module.exports = __webpack_public_path__ + "img/icon-dislike-white.89e4503e.svg";